<template>
    <div id="signup_v2" class="_bg-red-100 max-h-full">

        <div class="login_title mb-5">
            <p>
                Mes adresses de livraison
            </p>
            <p class="font-normal text-sm">
                (veuillez cocher votre adresse de livraison par défaut)
             </p>
        </div>

        <!-- old adresses -->
        <ul class="mb-15">
            <template v-for="(adress, idx_adress) in adresses">
                <li :key="'idx_adress' + idx_adress" class="mb-10 flex flex-row">
                    <div class="pr-5">
                        <input type="checkbox" @click="
                            adress.extra_infos.checked = !adress.extra_infos.checked;
                        updateAdress(adress)
                            " :checked="adress.extra_infos.checked ? 'checked' : ''" />
                    </div>
                    <div>
                        <div class="form-control">
                            <div class="form-element form-addresse">
                                <p class="form-title">
                                    Adresse de livraison / Rue et N° *
                                    <span v-if="parseInt(adress.default || 0)">(default)</span>
                                </p>
                                <input class="type_text" type="text" :value="adress.address" disabled />
                            </div>
                        </div>

                        <div class="form-control">
                            <div class="form-element">
                                <p class="form-title">Code postal *</p>
                                <input class="type_text" type="text" :value="adress.postal_code" disabled />
                            </div>
                            <div class="form-element">
                                <p class="form-title">Ville *</p>
                                <input class="type_text" type="text" :value="adress.city" disabled />
                            </div>
                            <div class="form-element">
                                <p class="form-title">Pays *</p>

                                <input class="type_text" type="text" :value="adress.country" disabled />
                            </div>
                        </div>

                        <div class="form-control" v-if="!parseInt(adress.default || 0)">
                            <div class="w-full flex justify-end">
                                <button @click="deleteAdress(adress)">Effacer</button>
                            </div>
                        </div>
                    </div>

                </li>
            </template>
        </ul>


        <!-- new adress -->
        <div class="border-t my-10" v-if="adresses.length"></div>

        <template v-if="isVisible">
            <div class="form-control">
                <div class="form-element form-addresse">
                    <p class="form-title">Adresse de livraison / Rue et N° *</p>
                    <input class="type_text" v-model="form_register.address" />
                </div>
            </div>

            <div class="form-control">
                <div class="form-element">
                    <p class="form-title">Code postal *</p>
                    <input class="type_text" v-model="form_register.postal_code" />
                </div>
                <div class="form-element">
                    <p class="form-title">Ville *</p>
                    <input class="type_text" v-model="form_register.city" />
                </div>
                <div class="form-element">
                    <p class="form-title">Pays *</p>
                    <select id="country" name="country" class="type_text" v-model="form_register.country">
                        <option value="Afghanistan">Afghanistan</option>
                        <option value="Åland Islands">Åland Islands</option>
                        <option value="Albania">Albania</option>
                        <option value="Algeria">Algeria</option>
                        <option value="American Samoa">American Samoa</option>
                        <option value="Andorra">Andorra</option>
                        <option value="Angola">Angola</option>
                        <option value="Anguilla">Anguilla</option>
                        <option value="Antarctica">Antarctica</option>
                        <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                        <option value="Argentina">Argentina</option>
                        <option value="Armenia">Armenia</option>
                        <option value="Aruba">Aruba</option>
                        <option value="Australia">Australia</option>
                        <option value="Austria">Austria</option>
                        <option value="Azerbaijan">Azerbaijan</option>
                        <option value="Bahamas">Bahamas</option>
                        <option value="Bahrain">Bahrain</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="Barbados">Barbados</option>
                        <option value="Belarus">Belarus</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Belize">Belize</option>
                        <option value="Benin">Benin</option>
                        <option value="Bermuda">Bermuda</option>
                        <option value="Bhutan">Bhutan</option>
                        <option value="Bolivia">Bolivia</option>
                        <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                        <option value="Botswana">Botswana</option>
                        <option value="Bouvet Island">Bouvet Island</option>
                        <option value="Brazil">Brazil</option>
                        <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                        <option value="Brunei Darussalam">Brunei Darussalam</option>
                        <option value="Bulgaria">Bulgaria</option>
                        <option value="Burkina Faso">Burkina Faso</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Cambodia">Cambodia</option>
                        <option value="Cameroon">Cameroon</option>
                        <option value="Canada">Canada</option>
                        <option value="Cape Verde">Cape Verde</option>
                        <option value="Cayman Islands">Cayman Islands</option>
                        <option value="Central African Republic">Central African Republic</option>
                        <option value="Chad">Chad</option>
                        <option value="Chile">Chile</option>
                        <option value="China">China</option>
                        <option value="Christmas Island">Christmas Island</option>
                        <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                        <option value="Colombia">Colombia</option>
                        <option value="Comoros">Comoros</option>
                        <option value="Congo">Congo</option>
                        <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                        <option value="Cook Islands">Cook Islands</option>
                        <option value="Costa Rica">Costa Rica</option>
                        <option value="Cote D'ivoire">Cote D'ivoire</option>
                        <option value="Croatia">Croatia</option>
                        <option value="Cuba">Cuba</option>
                        <option value="Cyprus">Cyprus</option>
                        <option value="Czech Republic">Czech Republic</option>
                        <option value="Denmark">Denmark</option>
                        <option value="Djibouti">Djibouti</option>
                        <option value="Dominica">Dominica</option>
                        <option value="Dominican Republic">Dominican Republic</option>
                        <option value="Ecuador">Ecuador</option>
                        <option value="Egypt">Egypt</option>
                        <option value="El Salvador">El Salvador</option>
                        <option value="Equatorial Guinea">Equatorial Guinea</option>
                        <option value="Eritrea">Eritrea</option>
                        <option value="Estonia">Estonia</option>
                        <option value="Ethiopia">Ethiopia</option>
                        <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                        <option value="Faroe Islands">Faroe Islands</option>
                        <option value="Fiji">Fiji</option>
                        <option value="Finland">Finland</option>
                        <option value="France">France</option>
                        <option value="French Guiana">French Guiana</option>
                        <option value="French Polynesia">French Polynesia</option>
                        <option value="French Southern Territories">French Southern Territories</option>
                        <option value="Gabon">Gabon</option>
                        <option value="Gambia">Gambia</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Germany">Germany</option>
                        <option value="Ghana">Ghana</option>
                        <option value="Gibraltar">Gibraltar</option>
                        <option value="Greece">Greece</option>
                        <option value="Greenland">Greenland</option>
                        <option value="Grenada">Grenada</option>
                        <option value="Guadeloupe">Guadeloupe</option>
                        <option value="Guam">Guam</option>
                        <option value="Guatemala">Guatemala</option>
                        <option value="Guernsey">Guernsey</option>
                        <option value="Guinea">Guinea</option>
                        <option value="Guinea-bissau">Guinea-bissau</option>
                        <option value="Guyana">Guyana</option>
                        <option value="Haiti">Haiti</option>
                        <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                        <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                        <option value="Honduras">Honduras</option>
                        <option value="Hong Kong">Hong Kong</option>
                        <option value="Hungary">Hungary</option>
                        <option value="Iceland">Iceland</option>
                        <option value="India">India</option>
                        <option value="Indonesia">Indonesia</option>
                        <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                        <option value="Iraq">Iraq</option>
                        <option value="Ireland">Ireland</option>
                        <option value="Isle of Man">Isle of Man</option>
                        <option value="Israel">Israel</option>
                        <option value="Italy">Italy</option>
                        <option value="Jamaica">Jamaica</option>
                        <option value="Japan">Japan</option>
                        <option value="Jersey">Jersey</option>
                        <option value="Jordan">Jordan</option>
                        <option value="Kazakhstan">Kazakhstan</option>
                        <option value="Kenya">Kenya</option>
                        <option value="Kiribati">Kiribati</option>
                        <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of
                        </option>
                        <option value="Korea, Republic of">Korea, Republic of</option>
                        <option value="Kuwait">Kuwait</option>
                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                        <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                        <option value="Latvia">Latvia</option>
                        <option value="Lebanon">Lebanon</option>
                        <option value="Lesotho">Lesotho</option>
                        <option value="Liberia">Liberia</option>
                        <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                        <option value="Liechtenstein">Liechtenstein</option>
                        <option value="Lithuania">Lithuania</option>
                        <option value="Luxembourg">Luxembourg</option>
                        <option value="Macao">Macao</option>
                        <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic
                            of
                        </option>
                        <option value="Madagascar">Madagascar</option>
                        <option value="Malawi">Malawi</option>
                        <option value="Malaysia">Malaysia</option>
                        <option value="Maldives">Maldives</option>
                        <option value="Mali">Mali</option>
                        <option value="Malta">Malta</option>
                        <option value="Marshall Islands">Marshall Islands</option>
                        <option value="Martinique">Martinique</option>
                        <option value="Mauritania">Mauritania</option>
                        <option value="Mauritius">Mauritius</option>
                        <option value="Mayotte">Mayotte</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                        <option value="Moldova, Republic of">Moldova, Republic of</option>
                        <option value="Monaco">Monaco</option>
                        <option value="Mongolia">Mongolia</option>
                        <option value="Montenegro">Montenegro</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Morocco">Morocco</option>
                        <option value="Mozambique">Mozambique</option>
                        <option value="Myanmar">Myanmar</option>
                        <option value="Namibia">Namibia</option>
                        <option value="Nauru">Nauru</option>
                        <option value="Nepal">Nepal</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="Netherlands Antilles">Netherlands Antilles</option>
                        <option value="New Caledonia">New Caledonia</option>
                        <option value="New Zealand">New Zealand</option>
                        <option value="Nicaragua">Nicaragua</option>
                        <option value="Niger">Niger</option>
                        <option value="Nigeria">Nigeria</option>
                        <option value="Niue">Niue</option>
                        <option value="Norfolk Island">Norfolk Island</option>
                        <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                        <option value="Norway">Norway</option>
                        <option value="Oman">Oman</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Palau">Palau</option>
                        <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                        <option value="Panama">Panama</option>
                        <option value="Papua New Guinea">Papua New Guinea</option>
                        <option value="Paraguay">Paraguay</option>
                        <option value="Peru">Peru</option>
                        <option value="Philippines">Philippines</option>
                        <option value="Pitcairn">Pitcairn</option>
                        <option value="Poland">Poland</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Qatar">Qatar</option>
                        <option value="Reunion">Reunion</option>
                        <option value="Romania">Romania</option>
                        <option value="Russian Federation">Russian Federation</option>
                        <option value="Rwanda">Rwanda</option>
                        <option value="Saint Helena">Saint Helena</option>
                        <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                        <option value="Saint Lucia">Saint Lucia</option>
                        <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                        <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                        <option value="Samoa">Samoa</option>
                        <option value="San Marino">San Marino</option>
                        <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                        <option value="Saudi Arabia">Saudi Arabia</option>
                        <option value="Senegal">Senegal</option>
                        <option value="Serbia">Serbia</option>
                        <option value="Seychelles">Seychelles</option>
                        <option value="Sierra Leone">Sierra Leone</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Slovakia">Slovakia</option>
                        <option value="Slovenia">Slovenia</option>
                        <option value="Solomon Islands">Solomon Islands</option>
                        <option value="Somalia">Somalia</option>
                        <option value="South Africa">South Africa</option>
                        <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich
                            Islands</option>
                        <option value="Spain">Spain</option>
                        <option value="Sri Lanka">Sri Lanka</option>
                        <option value="Sudan">Sudan</option>
                        <option value="Suriname">Suriname</option>
                        <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                        <option value="Swaziland">Swaziland</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                        <option value="Taiwan">Taiwan</option>
                        <option value="Tajikistan">Tajikistan</option>
                        <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                        <option value="Thailand">Thailand</option>
                        <option value="Timor-leste">Timor-leste</option>
                        <option value="Togo">Togo</option>
                        <option value="Tokelau">Tokelau</option>
                        <option value="Tonga">Tonga</option>
                        <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                        <option value="Tunisia">Tunisia</option>
                        <option value="Turkey">Turkey</option>
                        <option value="Turkmenistan">Turkmenistan</option>
                        <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                        <option value="Tuvalu">Tuvalu</option>
                        <option value="Uganda">Uganda</option>
                        <option value="Ukraine">Ukraine</option>
                        <option value="United Arab Emirates">United Arab Emirates</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="United States">United States</option>
                        <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                        <option value="Uruguay">Uruguay</option>
                        <option value="Uzbekistan">Uzbekistan</option>
                        <option value="Vanuatu">Vanuatu</option>
                        <option value="Venezuela">Venezuela</option>
                        <option value="Viet Nam">Viet Nam</option>
                        <option value="Virgin Islands, British">Virgin Islands, British</option>
                        <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                        <option value="Wallis and Futuna">Wallis and Futuna</option>
                        <option value="Western Sahara">Western Sahara</option>
                        <option value="Yemen">Yemen</option>
                        <option value="Zambia">Zambia</option>
                        <option value="Zimbabwe">Zimbabwe</option>
                    </select>
                </div>
            </div>

            <p class="required-fields mb-4">* Champs obligatoires</p>
            <!--  -->


            <div class="terms mb-4">
                <label class="terms_label">
                    J’accepte les
                    <a href="download/CGV.pdf" download>
                        conditions générales de vente
                        et déclaration de confidentialité
                    </a>
                    <input ref="checkbox" type="checkbox" @click.self="acceptTerms" />
                    <span class="checkmark"></span>
                </label>
            </div>

            <button type="button" class="max-w-max w-auto whitespace-nowrap px-5 btn sign-up-btn" @click="createAddress()">
                Ajouter une adresse de livraison
            </button>

        </template>

        <div class="mt-10">
            <p class="text-[13px]" @click="isVisible = !isVisible">
                <button
                    class="transform mr-2 relative rounded-full border border-gray-300 bg-gray-200 text-white w-7 h-7 inline-flex justify-center items-center text-4xl leading-none"
                    :class="[isVisible ? 'rotate-45' : 'rotate-0']">+</button>
                Ajouter une adresse de livraison supplémentaire
            </p>
        </div>


        <div class="mt-5 flex justify-end">
            <buton-return-v2></buton-return-v2>
        </div>
    </div>
</template>

<script>
import Autentification from '@/services/Autentification';
import Adresses from '@/services/Adresses';
import ButonReturnV2 from '@/components/v2/ButonReturnV2';

export default {
    name: 'MyAdressesV2',
    components:{
      ButonReturnV2
    },
    data() {
        return {
            terms_accepted: false,

            adresses: [],
            isVisible: false,

            form_register: {
                address: '',
                postal_code: '',
                city: '',
                country: '',
                terms_accepted: ''
            }
        };
    },
    computed: {
        openedFromCatalog(){
            return window.parent?.MainFrame || false
        }
    },
    mounted() {
        const vm = this;
        vm.uploadAddresses();
    },
    methods: {

        acceptTerms() {
            if (this.$refs.checkbox.checked) {
                this.form_register.terms_accepted = true;
            } else {
                this.form_register.terms_accepted = false;
            }
            console.log('Accept terms: ' + this.form_register.terms_accepted);
        },

        emptyFields() {
            const vm = this;
            vm.form_register = {
                address: '',
                postal_code: '',
                city: '',
                country: '',
                terms_accepted: ''
            }
        },

        uploadAddresses() {
            const vm = this;
            //
            setTimeout(() => {
                Adresses.readAll({
                    api_token: this.$store.state.api_token || '',
                }).then((response) => {
                    console.log({ response });
                    vm.adresses = response.data.data;
                }).catch((error) => {
                    console.error(error);
                }).then(() => {
                    vm.$store.commit('setAdresses', vm.adresses);
                    vm.$forceUpdate();
                });
            }, 100);
        },

        createAddress() {
            const vm = this;

            Adresses
                .create({
                    api_token: vm.$store.state.api_token || '',

                    address: vm.form_register.address,
                    postal_code: vm.form_register.postal_code,
                    city: vm.form_register.city,
                    country: vm.form_register.country,
                    extra_infos: JSON.stringify({
                        terms_accepted: vm.form_register.terms_accepted,
                        checked: false,
                    })
                })
                .then((response) => {

                    var data = response.data;

                    if (data && data.error) {
                        $eventbus.$emit('open:alert', data.error.message);
                    } else {
                        vm.emptyFields();
                        vm.uploadAddresses();
                        $eventbus.$emit('open:alert', " L'adresse a bien été ajoutée");
                    }

                })
                .catch((error) => {
                    console.error(error);
                    // $eventbus.$emit('open:alert', data.error.message);
                    $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');

                }).then(() => {
                    vm.$forceUpdate();
                });
        },

        deleteAdress(address) {
            const vm = this;

            Adresses
                .delete({
                    api_token: vm.$store.state.api_token || '',
                    id: address.id
                })
                .then((response) => {

                    var data = response.data;

                    if (data && data.error) {
                        $eventbus.$emit('open:alert', data.error.message);
                        alert('eroare_success');
                    } else {
                        vm.uploadAddresses();
                    }

                })
                .catch((error) => {
                    alert('eroare_catch');
                    console.error(error);
                    // $eventbus.$emit('open:alert', data.error.message);
                    $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');

                }).then(() => {
                    vm.$forceUpdate();
                });

        },

        updateAdress(address) {
            const vm = this;

            new Promise((resolve, reject) => {
                // toate adresele pe check:false
                if (vm.adresses.length) {
                    for (let i = 0; i < vm.adresses.length; i++) {
                        let a = vm.adresses[i];

                        if (a.id == address.id) {
                            if ((i + 1) >= vm.adresses.length) {
                                resolve();
                            }
                        } else {
                            a.extra_infos.checked = false;

                            Adresses
                                .update({
                                    api_token: vm.$store.state.api_token || '',

                                    id: a.id,

                                    address: a.address,
                                    postal_code: a.postal_code,
                                    city: a.city,
                                    country: a.country,
                                    extra_infos: JSON.stringify({
                                        terms_accepted: a.extra_infos.terms_accepted,
                                        checked: a.extra_infos.checked,
                                    })
                                })
                                .then(() => {
                                    if ((i + 1) >= vm.adresses.length) {
                                        resolve();
                                    }
                                });
                        }
                        //
                    }
                } else {
                    resolve();
                }
            }).then((response) => {

                Adresses
                    .update({
                        api_token: vm.$store.state.api_token || '',

                        id: address.id,

                        address: address.address,
                        postal_code: address.postal_code,
                        city: address.city,
                        country: address.country,
                        extra_infos: JSON.stringify({
                            terms_accepted: address.extra_infos.terms_accepted,
                            checked: address.extra_infos.checked,
                        })
                    })
                    .then((response) => {

                        var data = response.data;

                        if (data && data.error) {
                            $eventbus.$emit('open:alert', data.error.message);
                        } else {
                            vm.uploadAddresses();
                            // $eventbus.$emit('open:alert', "Address updated with success!");
                        }

                    })
                    .catch((error) => {
                        console.error(error);
                        // $eventbus.$emit('open:alert', data.error.message);
                        $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');

                    }).then(() => {
                        vm.$forceUpdate();
                    });

                return 0;
            });


        }
    }
};
</script>

<style lang="scss" scoped>
#signup_v2 {
    width: 100%;
    max-width: 586px;
    padding: 1rem;

    .login_title {
        font-size: 22px;
        font-weight: bold;
    }

    .form-control {
        * {
            user-select: none;
            font-size: 13px;
            color: #6b6c6f;
        }

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        @media (min-width: 768px) {
            flex-direction: row;
        }

        .form-element {
            margin-bottom: 1rem;
            width: 100%;

            &.form-addresse {
                width: 100%;
                margin-right: 0 !important;
            }

            @media (min-width: 768px) {
                width: 50%;
                margin-right: 1.5rem;

                &:last-of-type {
                    margin-right: 0;
                }
            }

            .type_text {
                width: 100%;
                border: 1px solid #dfe2e6;
                border-radius: 25px;
                padding-block: 0.2rem;
                padding-inline: 1rem;
                outline: none;
                color: #6b6c6f;
                font-size: 13px;

                &:focus {
                    border-color: #6b6c6f;
                }
            }

            .form-title {
                margin-bottom: 0.3rem;
                font-weight: bold;
            }

            .gender_wrapper {
                display: flex;

                .type_radio {
                    display: block;
                    position: relative;
                    padding-left: 15px;
                    cursor: pointer;
                    user-select: none;
                    margin-right: 1.5rem;

                    &:hover {
                        input {
                            ~ {
                                .checkmark {
                                    border-color: #01a0c6;
                                }
                            }
                        }
                    }

                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        pointer-events: none;

                        &:checked {
                            ~ {
                                .checkmark {
                                    background-color: #01a0c6;
                                    border: none;
                                }
                            }
                        }
                    }

                    .checkmark {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 12px;
                        width: 12px;
                        border: 1px solid #cccccc;
                        border-radius: 50%;
                    }
                }
            }
        }
    }

    .required-fields {
        font-size: 10px;
        color: #6b6c6f;
        text-align: center;
    }

    .terms {
        font-size: 12px;
        color: #6b6c6f;
        font-weight: bold;

        .terms_label {
            display: block;
            position: relative;
            cursor: pointer;
            user-select: none;
            padding-left: 26px;

            a {
                text-decoration: underline;
                color: #5882ff;
            }

            &:hover {
                input {
                    ~ {
                        .checkmark {
                            background-color: rgba(223, 226, 230, 0.2);
                            border-color: #4e4e4e;
                        }
                    }
                }
            }

            input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                width: 0;
                height: 0;

                &:checked {
                    ~ {
                        .checkmark {
                            background-color: #01a0c6;
                            border: none;

                            &:after {
                                display: block;
                            }
                        }
                    }
                }
            }

            .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 18px;
                width: 18px;
                border: 2px solid #dfe2e6;
                border-radius: 3px;
                transition: 0.5s;

                &::after {
                    content: '';
                    position: absolute;
                    display: none;
                    left: 7px;
                    top: 3px;
                    width: 5px;
                    height: 10px;
                    border: solid white;
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                }
            }
        }
    }

    .btn {
        font-size: 14px;
        outline: none;
        border: none;
        width: 100%;
        max-width: 160px;
        height: 40px;
        border-radius: 2rem;
        font-weight: 500;
        user-select: none;

        &.sign-up-btn {
            border: 2px solid #4e4e4e;
            color: #4e4e4e;
            max-width: unset;
            width:auto;
        }
    }
}
</style>
